import styled from "styled-components";

import "../../../../../GlobalStyles/Font.css";

export const ContainerForgotPassword = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

export const ContentModel = styled.div`
  max-width: 326px;
  background: #fff;
  border-radius: 20px;
  padding: 16px 20px;
  margin-bottom: 16px;
  margin-top: 16px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
  }

  @media (min-width: 1440px) {
    max-width: 449px;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f64747;
  border-radius: 50%;
  padding: 10px;
  width: 40px;
  height: 40px;

  cursor: pointer;

  @media (min-width: 1440px) {
    width: 60px;
    height: 60px;
  }
`;

export const TitleModel = styled.h1`
  font-size: 20px;
  font-family: "Exo2 Light";
  line-height: 1.2;

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;

export const ForgotPasswordForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
`;

export const EnterPasswordContainer = styled.div`
  position: relative;
`;

export const InputEnteredDataContainer = styled.div`
  max-width: 326px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  @media (min-width: 428px) {
    max-width: 372px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
  }
`;

export const InputEnteredData = styled.input`
  width: 100%;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  font-size: 20px;
  font-family: "Exo2 Light";
  line-height: 1.2;
  padding: 20px 25px;
  margin-top: 30px;

  @media (min-width: 1440px) {
    font-size: 24px;
  }
`;

export const EmailIconResetPassword = styled.svg`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 20px;
  top: 55px;
`;

export const ButtonSubmit = styled.input`
  background: #1a50c6;
  border-radius: 20px;
  font-size: 20px;
  font-family: "Exo2 SemiBold";
  line-height: 1.2;
  color: #fff;
  width: 100%;
  padding: 20px 0px 20px;
  margin-top: 34px;

  cursor: pointer;
`;
